import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export interface ContentLoaderListItemProps extends IContentLoaderProps {
  includeCheckbox?: boolean;
  includeAvatar?: boolean;
  includeSecondaryText?: boolean;
}

const ContentLoaderListItem: React.FC<ContentLoaderListItemProps> = ({
  includeCheckbox,
  includeAvatar,
  includeSecondaryText,
  ...rest
}) => {
  let x = 24;
  if (includeCheckbox) {
    x = 58;
  } else if (includeAvatar) {
    x = 70;
  }
  return (
    <ContentLoader width={300} height={47} {...rest}>
      {includeAvatar && <circle cx="39" cy="23" r="16" />}
      <rect x={x} y="18" rx="4" ry="4" width="120" height="10" />
      {includeSecondaryText && <rect x={x} y="38" rx="4" ry="4" width="150" height="7" />}
    </ContentLoader>
  );
};

export default ContentLoaderListItem;
